import React from "react";
import {
  Alert,
  Box,
  Button,
  Grid,
  Snackbar,
  TextField,
  Typography,
  FormControlLabel,
  Switch,
  InputAdornment,
  DialogActions,
  Divider,
  Skeleton,
} from "@mui/material";
import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import productsService from "../../../services/productsService";

const initialAlert = {
  severity: "success",
  message: "",
};

const CrearProducto = ({
  handleCreateProducto,
  productoSKU,
  handleCloseModal,
  secondaryLabel = "Cancelar",
  onSecondary,
  showBackIcon = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [alertObj, setAlertObj] = useState(initialAlert);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [sku, setSku] = useState("");
  const [nombre, setNombre] = useState("");
  const [ean, setEan] = useState("");
  const [alto, setAlto] = useState("");
  const [largo, setlargo] = useState("");
  const [ancho, setAncho] = useState("");
  const [peso, setPeso] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const userId = sessionStorage.getItem("User");
  const [error, setError] = useState({
    sku: "",
    nombre: "",
    ean: "",
    alto: "",
    largo: "",
    ancho: "",
    peso: "",
    observaciones: "",
  });

  useEffect(() => {
    if (productoSKU) {
      setLoadingSpinner(true);
      productsService
        .getProductsBySku(productoSKU)
        .then((res) => {
          let producto = Array.isArray(res.data) ? res.data[0] : res.data;

          if (producto) {
            setId(String(producto.id));
            setSku(String(producto.sku_id));
            setNombre(producto.name);
            setEan(producto.ean_id);
            setAlto(String(producto.height));
            setlargo(String(producto.deep));
            setAncho(String(producto.width));
            setPeso(String(producto.weight));
            setObservaciones(producto.observation);
            setIsChecked(producto.print_tag);
          } else {
            setAlertObj({
              severity: "error",
              message: "El producto no se encontro.",
            });
            setOpen(true);
          }
        })
        .catch(() => {
          setAlertObj({
            severity: "error",
            message: "Ocurrio un error al obtener el producto.",
          });
          setOpen(true);
        })
        .finally(() => {
          setLoadingSpinner(false);
        });
    }
  }, [productoSKU]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  function validarFormulario() {
    let isValid = true;
    let newError = {
      sku: "",
      nombre: "",
      ean: "",
      alto: "",
      largo: "",
      ancho: "",
      peso: "",
      observaciones: "",
    };
    if (sku.trim() === "") {
      newError.sku = "El SKU es obligatorio";
      isValid = false;
    }

    if (nombre.trim() === "") {
      newError.nombre = "El nombre es obligatorio";
      isValid = false;
    }

    if (ean.trim() === "") {
      newError.ean = "El EAN es obligatorio";
      isValid = false;
    }

    if (largo.trim() === "" || isNaN(largo) || parseInt(largo, 10) <= 0) {
      newError.largo = "Debe ser un numero positivo";
      isValid = false;
    }
    if (ancho.trim() === "" || isNaN(ancho) || parseInt(ancho, 10) <= 0) {
      newError.ancho = "Debe ser un numero positivo";
      isValid = false;
    }
    if (alto.trim() === "" || isNaN(alto) || parseInt(alto, 10) <= 0) {
      newError.alto = "Debe ser un numero positivo";
      isValid = false;
    }
    if (peso.trim() === "" || isNaN(peso) || parseInt(peso, 10) <= 0) {
      newError.peso = "Debe ser un numero positivo";
      isValid = false;
    }

    setError(newError);

    if (!isValid) {
      return false;
    }

    return true;
  }

  async function handleEditProduct() {
    if (!validarFormulario()) {
      return;
    }
    try {
      setLoading(true);
      let newProduct = await productsService.putProducts({
        id: parseInt(id),
        sku_id: sku,
        name: nombre,
        ean_id: ean,
        height: parseFloat(alto),
        deep: parseFloat(largo),
        width: parseFloat(ancho),
        weight: parseFloat(peso),
        observation: observaciones,
        print_tag: JSON.parse(isChecked),
        user_id: parseInt(userId, 10),
      });
      if (newProduct?.data) {
        setAlertObj({
          severity: "success",
          message: "Producto editado exitosamente",
        });
        setLoading(false);
        setOpen(true);
        setTimeout(() => {
          handleCreateProducto();
          handleCloseModal();
        }, 1500);
      }
    } catch {
      setAlertObj({
        severity: "error",
        message: "Ocurrio un error en la edicion",
      });
      setLoading(false);
      setOpen(true);
    }
  }

  const handleCreateProduct = async () => {
    if (!validarFormulario()) {
      return;
    }
    try {
      setLoading(true);
      let newProduct = await productsService.postProduct({
        user_id: parseInt(userId, 10),
        sku_id: sku,
        name: nombre,
        ean_id: ean,
        height: parseFloat(alto),
        deep: parseFloat(largo),
        width: parseFloat(ancho),
        weight: parseFloat(peso),
        observation: observaciones,
        print_tag: isChecked,
      });
      if (newProduct?.data) {
        setAlertObj({
          severity: "success",
          message: "Se creo el producto exitosamente",
        });
        setLoading(false);
        setOpen(true);
        setTimeout(() => {
          handleCreateProducto();
          handleCloseModal();
        }, 2000);
      }
    } catch (error) {
      const errorMessage = error.response?.data || error.message;

      setAlertObj({
        severity: "error",
        message: errorMessage.includes("sku_id ya esta registrado")
          ? "El SKU ingresado ya existe."
          : "Ocurrio un error en la creacion.",
      });

      setLoading(false);
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  if (loadingSpinner) {
    return (
      <Box sx={{ py: 2 }}>
        <Grid container spacing={2}>
          {[...Array(6)].map((_, i) => (
            <Grid item xs={12} sm={6} key={i}>
              <Skeleton variant="rounded" height={56} />
            </Grid>
          ))}
          <Grid item xs={12}>
            <Skeleton variant="rounded" height={80} />
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <Box sx={{ pt: 1 }}>
      {/* Seccion: Identificacion */}
      <Typography
        variant="overline"
        color="text.secondary"
        fontWeight={600}
        sx={{ display: "block", mb: 1.5 }}
      >
        Identificacion del producto
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="SKU"
            placeholder="Ej: SKU-001"
            variant="outlined"
            size="small"
            disabled={Boolean(productoSKU)}
            fullWidth
            required
            value={sku}
            onChange={(e) => {
              const inputValue = e.target.value.toUpperCase();
              setSku(inputValue);
              setError({ ...error, sku: "" });
            }}
            error={Boolean(error.sku)}
            helperText={error.sku}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Nombre"
            placeholder="Ej: MACETA GRANDE"
            variant="outlined"
            size="small"
            fullWidth
            required
            value={nombre}
            onChange={(e) => {
              setNombre(e.target.value.toUpperCase());
              setError({ ...error, nombre: "" });
            }}
            error={Boolean(error.nombre)}
            helperText={error.nombre}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="EAN"
            placeholder="Ej: 7790001234567"
            variant="outlined"
            size="small"
            fullWidth
            required
            value={ean}
            onChange={(e) => {
              const regex = /^[a-zA-Z0-9]*$/;
              const inputValue = e.target.value.toUpperCase();
              if (inputValue.length > 14) return;
              if (!regex.test(inputValue)) return;
              setEan(inputValue);
              setError({ ...error, ean: "" });
            }}
            error={Boolean(error.ean)}
            helperText={error.ean || "Maximo 14 caracteres"}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Peso"
            placeholder="Ej: 500"
            variant="outlined"
            size="small"
            fullWidth
            required
            value={peso}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography variant="caption" color="text.secondary">g</Typography>
                </InputAdornment>
              ),
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^[0-9]*$/;
              if (regex.test(value) || value === "") {
                setPeso(value);
                setError({ ...error, peso: "" });
              }
            }}
            error={Boolean(error.peso)}
            helperText={error.peso}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
        </Grid>
      </Grid>

      {/* Seccion: Dimensiones */}
      <Divider sx={{ my: 2.5 }} />
      <Typography
        variant="overline"
        color="text.secondary"
        fontWeight={600}
        sx={{ display: "block", mb: 1.5 }}
      >
        Dimensiones
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Alto"
            placeholder="0"
            variant="outlined"
            size="small"
            fullWidth
            required
            value={alto}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography variant="caption" color="text.secondary">cm</Typography>
                </InputAdornment>
              ),
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^[0-9]*$/;
              if (regex.test(value) || value === "") {
                setAlto(value);
                setError({ ...error, alto: "" });
              }
            }}
            error={Boolean(error.alto)}
            helperText={error.alto}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Largo"
            placeholder="0"
            variant="outlined"
            size="small"
            fullWidth
            required
            value={largo}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography variant="caption" color="text.secondary">cm</Typography>
                </InputAdornment>
              ),
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^[0-9]*$/;
              if (regex.test(value) || value === "") {
                setlargo(value);
                setError({ ...error, largo: "" });
              }
            }}
            error={Boolean(error.largo)}
            helperText={error.largo}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Ancho"
            placeholder="0"
            variant="outlined"
            size="small"
            fullWidth
            required
            value={ancho}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography variant="caption" color="text.secondary">cm</Typography>
                </InputAdornment>
              ),
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^[0-9]*$/;
              if (regex.test(value) || value === "") {
                setAncho(value);
                setError({ ...error, ancho: "" });
              }
            }}
            error={Boolean(error.ancho)}
            helperText={error.ancho}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
        </Grid>
      </Grid>

      {/* Seccion: Adicional */}
      <Divider sx={{ my: 2.5 }} />
      <Typography
        variant="overline"
        color="text.secondary"
        fontWeight={600}
        sx={{ display: "block", mb: 1.5 }}
      >
        Informacion adicional
      </Typography>

      <TextField
        label="Observaciones"
        placeholder="Notas internas sobre el producto..."
        variant="outlined"
        size="small"
        fullWidth
        multiline
        rows={3}
        value={observaciones}
        onChange={(e) => setObservaciones(e.target.value)}
        error={Boolean(error.observaciones)}
        helperText={
          error.observaciones ||
          `${observaciones.length}/160 caracteres`
        }
        inputProps={{ maxLength: 160 }}
        sx={{
          mb: 1.5,
          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
        }}
      />

      <FormControlLabel
        control={
          <Switch
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            color="primary"
          />
        }
        label={
          <Box>
            <Typography variant="body2" fontWeight={500}>
              Necesita reetiquetado
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Marcar si el producto requiere nueva etiqueta al ingresar
            </Typography>
          </Box>
        }
        sx={{
          ml: 0,
          alignItems: "flex-start",
          "& .MuiSwitch-root": { mt: 0.5 },
        }}
      />

      {/* Footer actions */}
      <DialogActions sx={{ px: 0, pt: 2.5, pb: 0, justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          onClick={onSecondary || handleCloseModal}
          disabled={loading}
          startIcon={showBackIcon ? <ArrowBackIcon /> : null}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            borderColor: "#cbd5e1",
            color: "#475569",
            "&:hover": { borderColor: "#94a3b8", backgroundColor: "#f8fafc" },
          }}
        >
          {secondaryLabel}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={productoSKU ? handleEditProduct : handleCreateProduct}
          sx={{
            textTransform: "none",
            px: 3,
            borderRadius: "8px",
            fontWeight: 600,
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: "white", mr: 1 }} />
          ) : null}
          {loading
            ? productoSKU
              ? "Guardando..."
              : "Creando..."
            : productoSKU
              ? "Guardar cambios"
              : "Crear producto"}
        </Button>
      </DialogActions>

      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={alertObj?.severity}
          sx={{ width: "100%" }}
        >
          {alertObj.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CrearProducto;
